export default __webpack_public_path__ + "static/marcel_bednarz-9a0375e0ff7d11ae64fead1b26a4ba26.png";